<template>
  <div class="c-side-nav">
    <plv-breakpoint-div class="c-side-nav-logo">
      <div
        class="c-side-nav-logo__img"
        :style="{
          backgroundImage: `url(${customLogo})`,
          backgroundRepeat: 'no-repeat',
        }"
      ></div>
    </plv-breakpoint-div>
    <div class="c-side-nav-menu">
      <plv-menu
        use-router-link
      >
        <plv-menu-item
          index="/group/overview"
          icon="order-list"
          title="概览"
        />
        <plv-menu-item
          index="/group/allocatableResources"
          icon="order-list"
          title="分配记录"
        />
        <plv-menu-item
          index="/group/accountAdd"
          icon="order-list"
          title="新增分账号"
        />
        <plv-menu-item
          index="/group/accountManagement"
          icon="order-list"
          title="分账号管理"
        />
        <plv-menu-item
          index="/group/billStatistics"
          icon="order-list"
          title="账单统计"
        />
        <plv-menu-item
          index="/group/businessUsage"
          icon="order-list"
          title="业务用量"
        />
        <plv-menu-item
          index="/group/liveBroadcastStatistics"
          icon="order-list"
          title="直播场次统计"
        />
        <plv-menu-item
          index="/group/brandCustom"
          icon="order-list"
          title="品牌定制"
        />
        <plv-menu-item
          index="/group/developInfo"
          icon="order-list"
          title="开发设置"
        />
      </plv-menu>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
const defaultLogo = require('../../assets/images/logo.svg');
export default {
  data() {
    return {
      activeIndex: '/group'
    };
  },
  computed: {
    ...mapState({
      customInfo: (state) => state.account.customInfo,
    }),
    customLogo() {
      const { customLogo, customBrandEnabled } = this.customInfo ?? {};
      return this.ynToBool(customBrandEnabled || 'N') && customLogo ? customLogo : defaultLogo;
    },
  },
  methods: {
    handleMenuSelect(index) {
      this.activeIndex = index;
    }
  }
};
</script>

<style lang="scss">
.c-side-nav {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 3;
  height: 100%;
  .c-side-nav-logo {
    height: 56px;
    width: 100%;
    box-sizing: border-box;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    padding-left: 24px;
    transition: 0.3s;
    position: relative;
    z-index: 3;
    background: #00284D;
    &__img {
      flex: 1;
      height: 20px;
      margin-left: 14px;
      margin-right: 14px;
      background: url('../../assets/images/logo.svg') no-repeat;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: left center;
    }
  }
  .c-side-nav-menu {
    flex: 1;
    overflow: hidden;
    position: relative;
    z-index: 2;
  }
}
</style>
